export default __webpack_public_path__ + "static/media/img2.1aac5d7b.png";